import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import FormEdit from '../../../../components/auth/contas/listar/form_edit'
import Head from '../../../../components/head'


function EditarContasScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Documento da Prestação de Contas" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarContasScreen;